// extracted by mini-css-extract-plugin
module.exports = {"titleFilter":"index_titleFilter__tA6xv","input":"index_input__byfw9","suffix":"index_suffix__EMOzG"};